import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { locator } from '../../testing/e2e-locator/locator';
import { Button } from '../Button/Button';

export const ApplicationUpdatedModal = (): ReactNode => {
  const { t } = useTranslation();

  const reloadPageClicked = (): void => {
    window.location.reload();
  };

  return (
    <Modal data-testid={locator.components.applicationUpdateModal.root} open>
      <Box>
        <header
          data-testid={locator.components.applicationUpdateModal.header.root}
        >
          <h1 data-testid={locator.components.applicationUpdateModal.header.h1}>
            {t('applicationUpdatedModal.title')}
          </h1>
        </header>
        <div>
          <main
            data-testid={locator.components.applicationUpdateModal.main.root}
          >
            <p data-testid={locator.components.applicationUpdateModal.main.p}>
              {t('applicationUpdatedModal.content')}
            </p>
          </main>
          <footer
            data-testid={locator.components.applicationUpdateModal.footer.root}
          >
            <Button
              data-testid={
                locator.components.applicationUpdateModal.footer
                  .reloadPageButton
              }
              onClick={reloadPageClicked}
            >
              {t('applicationUpdatedModal.reloadPage')}
            </Button>
          </footer>
        </div>
      </Box>
    </Modal>
  );
};
